export const I18N_DEFAULT_NS = 'translations';
export const TRANSLATIONS_DIRECTORY = 'i18n';
